// Individual schedule list for the Live tab: the team's (or referee's) games
// grouped by day, with the next game highlighted and past games muted

import moment from 'moment-timezone';
import { useFirebase } from './FirebaseContextProvider';
import { timeStr } from '../utils/misc';
import {
  sortGamesChrono,
  gameEndMoment,
  gameTypeLabel,
  fieldName,
  matchupLabel,
} from '../utils/live';
import './LiveSchedule.scss';

export default function LiveSchedule({
  tournament,
  games,
  teamId,
  now,
  nextGameId,
}) {
  const { teamsById } = useFirebase();

  const sorted = sortGamesChrono(games);
  const days = [];
  for (const game of sorted) {
    const last = days[days.length - 1];
    if (last && last.date === game.date) last.games.push(game);
    else days.push({ date: game.date, games: [game] });
  }

  return (
    <div className='live-schedule'>
      {!sorted.length && <p className='empty'>No games scheduled yet</p>}
      {days.map(({ date, games: dayGames }) => (
        <div className='day' key={date}>
          <h6>{moment(date, 'YYYY-MM-DD').format('dddd, MMMM D')}</h6>
          <ul>
            {dayGames.map((game) => {
              const isPast = !gameEndMoment(tournament, game).isAfter(now);
              const isNext = game.id === nextGameId;
              const played = game.score1 != null && game.score2 != null;

              let result = '';
              if (played && teamId) {
                const my = game.team1 === teamId ? game.score1 : game.score2;
                const opp = game.team1 === teamId ? game.score2 : game.score1;
                result = my > opp ? 'W' : my < opp ? 'L' : 'T';
              }

              return (
                <li
                  className={`game${isPast ? ' past' : ''}${isNext ? ' highlight' : ''}`}
                  key={game.id}
                >
                  <div className='info'>
                    <span className='time'>
                      {timeStr(game.start, game.duration)}
                    </span>
                    <span className='matchup'>
                      {matchupLabel(teamsById, game, teamId)}
                    </span>
                    <span className='meta'>
                      <span className='type'>{gameTypeLabel(game)}</span>
                      <span className='field-name'>
                        {fieldName(tournament, game)}
                      </span>
                    </span>
                  </div>
                  <span className='outcome'>
                    <span
                      className={`result${result ? ` result-${result}` : ''}`}
                    >
                      {result}
                    </span>
                    <span className='score'>
                      {played ? `${game.score1}:${game.score2}` : '-'}
                    </span>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
